import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import { TerraIconModule } from '@ninety/terra';
import { ButtonComponent } from '@ninety/ui/core';

import { GuideActions } from '../../_state/guide.actions';
import { Phase } from '../../models/phase';
import { PhaseStepComponent } from '../phase-step/phase-step.component';

@Component({
  selector: 'ninety-phase-details',
  templateUrl: './phase-details.component.html',
  styleUrls: ['./phase-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonComponent, TerraIconModule, PhaseStepComponent],
})
export class PhaseDetailsComponent {
  private store = inject(Store);

  @Input() phase: Phase;
  @Input() mazChatEnabled: boolean;

  close(): void {
    this.store.dispatch(GuideActions.closeGuide());
  }

  goBack(): void {
    this.store.dispatch(GuideActions.closePhaseDetails());
  }
}
